<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<app-header-page>
    <app-component-button-header-back *ngIf="alias" href="/account/tasks/all/{{filter}}">
        {{ 'HEADERS.ALL_BP' | translate }}
    </app-component-button-header-back>
    <h1 *ngIf="board === 'my'">{{ 'HEADERS.MY_TASKS' | translate }}</h1>
</app-header-page>

<!-- задачи в таблице -->
<div *ngIf="board === 'my'" class="container-fluid">
    <app-component-button-create-task
            (eminOnCreateTask)="onCreateTask($event)"
            (emitSaveSettings)="emitSaveSettings.emit($event)"
            [isShowBoardButton]="alias ? false : board === 'all'"
    ></app-component-button-create-task>
    <app-component-tasks-table
            [isMini]="false"
            [emitReload]="emitReloading"
            [emitSaveSettings]="emitSaveSettings"
            [searchType]="board"
    ></app-component-tasks-table>
</div>
<!-- задачи в таблице END -->

<!-- борды с переключением на колонки -->

<div *ngIf="board === 'all'" style="margin-left: 8px; margin-right: 8px;">
    <div class="create-wrap" style="margin-top: 12px; margin-bottom: 12px;">
        <app-component-button-create-task
                (eminOnCreateDashboard)="reload()"
                (eminOnCreateTask)="onCreateTask($event)"
                (emitAddRange)="range = $event"
                (emitChangeDesk)="changeViewType($event)"
                (emitSaveSettings)="emitSaveSettings.emit($event); reloadAfterDelete($event)"
                [isShowBoardButton]="alias ? false : board === 'all'"
                [viewType]="viewType"
        ></app-component-button-create-task>

    </div>
    <div *ngIf="!alias">
        <app-task-dashboards-v3 
                             *ngIf="boards; else loading"
                             [allGroups]="boardGroups"
                             [boards]="boards"
                             (emitReloading)="reload()"
        ></app-task-dashboards-v3>
<!--         <app-task-dashboards (emitReloading)="reload()"
                             *ngIf="boards; else loading"
                             [boardGroups]="boardGroups"
                             [boards]="boards"
        ></app-task-dashboards> -->
    </div>
    <app-task-column
            *ngIf="alias && viewType === 'column'"
            [emitReload]="emitReloading"
            [emitSaveSettings]="emitSaveSettings"
            [range]="range"
    ></app-task-column>
    <app-component-tasks-table
            *ngIf="alias && viewType === 'table'"
            [isMini]="false"
            [emitReload]="emitReloading"
            [emitSaveSettings]="emitSaveSettings"
            [range]="range"
            [searchType]="board"
    ></app-component-tasks-table>

    <div *ngIf="alias && viewType === 'logs'">
        <app-task-detail-logs
                *ngIf="boardLife.length"
                [boardLife]="boardLife"
        ></app-task-detail-logs>
        <div *ngIf="!boardLife.length">
            <h2>{{ 'EMPTY_LISTS.LOGS' | translate }}</h2>
        </div>
        <app-component-pagination
                (page)="getLogs($event)"
                [pagination]="pagination"
                [totalPages]="pagination.pages"
        ></app-component-pagination>
    </div>
</div>
<!-- борды с переключением на колонки END -->
